import type React from 'react';
import type { PropsWithChildren } from 'react';

import st from './BaseGeneralEventInfo.module.sass';

function BaseGeneralEventInfo({
  children,
}: PropsWithChildren): React.JSX.Element {
  return (
    <div className={st.BaseGeneralEventInfo}>
      {children}
    </div>
  );
}

export { BaseGeneralEventInfo };
